var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.384 29.6191L16.855 23.0901C18.2801 21.2167 18.9405 18.8719 18.7024 16.5302C18.4644 14.1884 17.3457 12.0245 15.5728 10.4762C13.7999 8.92795 11.5051 8.11089 9.15258 8.19036C6.8001 8.26982 4.56563 9.23988 2.90123 10.9043C1.23683 12.5687 0.266771 14.8032 0.187304 17.1556C0.107838 19.5081 0.9249 21.8029 2.47319 23.5759C4.02147 25.3488 6.18539 26.4674 8.52714 26.7055C10.8689 26.9435 13.2136 26.2832 15.087 24.8581L21.616 31.3871C21.8525 31.6177 22.1697 31.7468 22.5 31.7468C22.8303 31.7468 23.1475 31.6177 23.384 31.3871C23.6182 31.1525 23.7498 30.8345 23.7498 30.5031C23.7498 30.1716 23.6182 29.8536 23.384 29.6191ZM2.75 17.5001C2.75 16.165 3.14588 14.86 3.88758 13.75C4.62928 12.6399 5.68349 11.7748 6.91689 11.2639C8.15029 10.753 9.50749 10.6193 10.8169 10.8798C12.1262 11.1402 13.329 11.7831 14.273 12.7271C15.217 13.6711 15.8598 14.8738 16.1203 16.1832C16.3808 17.4926 16.2471 18.8498 15.7362 20.0832C15.2253 21.3166 14.3601 22.3708 13.2501 23.1125C12.1401 23.8542 10.835 24.2501 9.5 24.2501C7.71044 24.2479 5.99478 23.5361 4.72937 22.2707C3.46396 21.0053 2.75212 19.2896 2.75 17.5001Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.9240d9a34040f5dba127608190c99652.svg";
export { ForwardRef as ReactComponent };